import { InformationCircleIcon } from "@heroicons/react/outline";
import { AdditionalField } from "@prisma/client";
import {
  InputSelect,
  InputToggle,
  InputPhone,
  Input,
  InputDate,
} from "components/Inputs";

interface FieldRendererProps {
  field: AdditionalField;
  disabled?: boolean;
}
const FieldRenderer: React.FC<FieldRendererProps> = ({ field, disabled }) => {
  switch (field.type) {
    case "DATE":
      return (
        <InputDate
          name={field.id}
          label={field.title}
          disabled={disabled}
          helperText={field.helperText}
          availableDays={
            field.availableDays?.split(",").map((day) => parseInt(day)) || []
          }
        />
      );
    case "TEXT":
      return (
        <Input
          name={field.id}
          label={field.title || ""}
          type="textarea"
          helperText={field.helperText}
          disabled={disabled}
        />
      );
    case "SHORT_TEXT":
      return (
        <Input
          name={field.id}
          label={field.title}
          type="text"
          helperText={field.helperText}
          disabled={disabled}
        />
      );
    case "DROPDOWN":
      if (!field.optionsList) return null;
      return (
        <InputSelect
          name={field.id}
          label={field.title}
          helperText={field.helperText}
          disabled={disabled}
          options={field.optionsList?.split(",").map((o) => ({
            label: o,
            value: o,
          }))}
        />
      );
    case "BOOLEAN":
      return (
        <InputToggle
          name={field.id}
          label={field.title}
          disabled={disabled}
          helperText={field.helperText}
        />
      );
    case "NUMBER":
      return (
        <Input
          type="number"
          name={field.id}
          label={field.title}
          disabled={disabled}
          helperText={field.helperText}
        />
      );
    case "PHONE_NUMBER":
      return (
        <InputPhone
          name={field.id}
          label={field.title}
          disabled={disabled}
          helperText={field.helperText}
        />
      );
    case "MESSAGE":
      if (!field.message) return null;
      return (
        <div className="text-sm p-2 bg-gray-100 rounded-lg my-2">
          <h2 className="font-semibold mb-1 text-input">{field.title}</h2>
          <p className="whitespace-pre-line">{field.message}</p>
        </div>
      );
  }
};

export default FieldRenderer;
